import { Button, Flex, Modal } from "antd";

import React from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../../common/customTitle";
import { deleteOfferById } from "../../../../../../redux/services/offer/offerServices";
import { useTranslation } from "react-i18next";

const OfferDeleteDialog = ({ open, onClose }) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { selectedOfferId } = useSelector((state) => state?.offers);

  const handleDelete = () => {
    if (
      selectedOfferId &&
      selectedOfferId !== "" &&
      selectedOfferId !== null &&
      selectedOfferId !== undefined
    ) {
      const offerBody = {
        selectedOfferId,
      };

      dispatch(deleteOfferById(offerBody, navigate, setLoading)).then(() => {
        onClose();
      });
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Modules.Offer.OfferForm.deleteOffer")}
        </CustomTitle>
        <Title level={2}>{t("deleteTitle")}</Title>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleDelete}>
            {t("confirmationPopup.buttonYesText")}
          </Button>
          <Button type="default" onClick={onClose}>
            {t("confirmationPopup.buttonNoText")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default OfferDeleteDialog;
